"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../analytics");
class AnalyticsServiceGR extends _analytics.AnalyticsService {
  startJourney() {
    var _window$guidedSelling, _window;
    if (typeof ((_window$guidedSelling = window.guidedSelling) === null || _window$guidedSelling === void 0 ? void 0 : _window$guidedSelling.analyticsStart) !== 'function') {
      return super.startJourney();
    }
    return (_window = window) === null || _window === void 0 ? void 0 : _window.guidedSelling.analyticsStart();
  }
  endJourney(_ref) {
    var _window$guidedSelling2;
    let {
      handsetProductName,
      planProductName,
      broadbandProductName
    } = _ref;
    if (typeof ((_window$guidedSelling2 = window.guidedSelling) === null || _window$guidedSelling2 === void 0 ? void 0 : _window$guidedSelling2.analyticsEnd) !== 'function') {
      return super.endJourney({
        handsetProductName,
        planProductName,
        broadbandProductName
      });
    }
    return window.guidedSelling.analyticsEnd(handsetProductName);
  }
}
var _default = AnalyticsServiceGR;
exports.default = _default;